
export const getProgressColor = (progress: number): string => {
  if (progress < 30) return 'bg-red-400';
  if (progress < 70) return 'bg-yellow-400';
  return 'bg-green-400';
};

export const globalFilterFn = (viewMode: 'tree' | 'table', globalFilter: string) => {
  return (row: any, columnId: any, filterValue: string) => {
    if (!filterValue) return true;
    
    const search = filterValue.toLowerCase();
    const item = row.original;
    
    // Skip group headers when they appear (they won't when searching in tree view)
    if (item.isGroupHeader) {
      return false;
    }
    
    // Collect ALL searchable text from the item
    const searchableFields = [
      item.fileName,
      item.description,
      item.level1,
      item.level2,
      item.link,
      item.progress?.toString(),
      ...(item.tags || []),
      // Add comments text if any
      ...(item.comments || []).map((c: any) => c.text),
      // Add any other string fields from metadata
      item.metadata?.author,
      item.metadata?.version?.toString(),
    ].filter(Boolean);
    
    const searchableText = searchableFields.join(' ').toLowerCase();
    return searchableText.includes(search);
  };
};